module.exports = __webpack_public_path__ + "static/media/nmd2023.dd46a296.jpeg";